import React, { FC } from 'react';
import Svg, { Path } from 'react-native-svg';
import { Image, View } from 'react-native';

import { CongratsBadgeKind, congratsBadgeSource } from './congratsBadges';

/**
 * figma: ❖ Congrats screen badge — module-colored hexagon illustration with
 * the design's gold four-point sparkles around it.
 */
interface CongratsBadgeProps {
  kind: CongratsBadgeKind;
  designSystemColor?: string | null;
  size?: number;
}

const GOLD = '#F0C64B';

const Sparkle: FC<{ size: number }> = ({ size }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24">
    <Path
      d="M12 0C12.9 6.2 14.9 8.6 24 12C14.9 15.4 12.9 17.8 12 24C11.1 17.8 9.1 15.4 0 12C9.1 8.6 11.1 6.2 12 0Z"
      fill={GOLD}
    />
  </Svg>
);

export const CongratsBadge: FC<CongratsBadgeProps> = ({
  kind,
  designSystemColor,
  size = 180,
}) => {
  return (
    <View style={{ width: size * 1.5, height: size * 1.3, alignItems: 'center', justifyContent: 'center' }}>
      <Image
        source={congratsBadgeSource(kind, designSystemColor)}
        style={{ width: size, height: size * 1.06 }}
        resizeMode="contain"
      />
      <View style={{ position: 'absolute', top: 0, right: size * 0.08 }}>
        <Sparkle size={size * 0.14} />
      </View>
      <View style={{ position: 'absolute', bottom: size * 0.16, right: 0 }}>
        <Sparkle size={size * 0.19} />
      </View>
      <View style={{ position: 'absolute', bottom: size * 0.05, left: size * 0.02 }}>
        <Sparkle size={size * 0.16} />
      </View>
      <View style={{ position: 'absolute', bottom: size * 0.18, left: size * 0.14 }}>
        <Sparkle size={size * 0.08} />
      </View>
    </View>
  );
};
